// extracted by mini-css-extract-plugin
export default {"picture-wrapper":"LP2ZJ","picture-block":"LfxD4","img":"z1LBl","file-loader-wrapper":"JAAwV","file-loader":"C1Hmk","delete-btn":"gnrVD","loader":"TayrJ"};